import { Controller, Control, FieldValues, Path } from 'react-hook-form';
import { Box, Switch, Tooltip } from '../../base-components';

interface Props<F extends FieldValues> {
    name: Path<F>;
    control: Control<F>;
    readOnly?: boolean;
    disabled?: boolean;
    dataTestId?: string;
    toggleContainerTooltip?: string;
    onChange?: (checked: boolean) => void;
}

const FormSwitch = <F extends FieldValues>(props: Props<F>) => {
    const {
        name,
        control,
        readOnly,
        disabled,
        dataTestId,
        toggleContainerTooltip,
        onChange,
    } = props;

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                return (
                    <Tooltip
                        title={toggleContainerTooltip}
                        placement="top-start"
                        followCursor={false}
                        arrow
                    >
                        <Box>
                            <Switch
                                disabled={disabled}
                                readOnly={readOnly}
                                data-testid={dataTestId || name}
                                checked={Boolean(field.value)}
                                {...field}
                                onClick={() => {
                                    const newValue = !field.value;
                                    field.onChange(newValue);
                                    onChange?.(newValue);
                                }}
                            />
                        </Box>
                    </Tooltip>
                );
            }}
        />
    );
};

export default FormSwitch;
